var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement } from 'lit';
import { property } from 'lit/decorators.js';
// Mixins
import { ScopedElements } from '@frontend_zz/web-component-mixins/ScopedElements/ScopedElements.js';
import Analytics from '@frontend_zz/web-component-mixins/Analytics/Analytics.js';
import { Resizable } from '@frontend_zz/web-component-mixins/Resizable/Resizable.js';
export class BaseElement extends Resizable(Analytics(ScopedElements(LitElement))) {
    constructor() {
        super(...arguments);
        this.theme = 'white';
        this.testAndAnalyticsContext = this.nodeName.toLowerCase();
    }
}
__decorate([
    property({ reflect: true })
], BaseElement.prototype, "theme", void 0);
__decorate([
    property({ attribute: 'test-and-analytics-context', reflect: true })
], BaseElement.prototype, "testAndAnalyticsContext", void 0);
